<ng-container *transloco="let t">
  @if (form$ | async; as form) {
    @let telemonitoringUsers = telemonitoringUsers$ | async;
    <tui-elastic-container class="min-h-80 *:block *:pb-4" [formGroup]="form">
      @if (telemonitoringUsers?.length > 0) {
        <pxc-telemonitoring-collaborators
          formControlName="collaborators"
          [departmentIds]="departmentIds"
          [readonlyUserIds]="readonlyUserIds$ | async" />
        <div class="mt-2 flex flex-wrap items-center gap-2 md:gap-4">
          <button appearance="outline" data-testid="submit-button" tuiButton type="button" (click)="cancel()">
            {{ t('Annuler') }}
          </button>
          <button class="ml-auto" data-testid="submit-button" tuiButton type="button" (click)="submit(form)">
            {{ t('Valider') }}
          </button>
        </div>
      }
    </tui-elastic-container>
  } @else {
    <pxc-loader class="my-5" data-testid="loading">
      {{ t('Chargement des utilisateurs ...') }}
    </pxc-loader>
  }
</ng-container>
